<!-- Spinner -->
<div style="height:100%; text-align: center;">
  <mat-spinner id="loading-spinner"></mat-spinner>
  <!-- Spinner Text -->
  <label id="loading-modal-message-text" style="margin-top: 12px;"> {{ data.modalMessageText }} </label>
</div>
